import React, { useEffect } from "react";
import { useForm } from "react-hook-form"; // Import useForm from react-hook-form
import { PatchRequest } from "../../Api/ApiFunctions";
import { ApiUrl, ConfUrl } from "../../Api/EndPoints";
import Select from "react-select";
// import { Modal } from "react-bootstrap";

const EditContactUs = ({ OnFinish, editData, fulldata }) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { isSubmitting },
  } = useForm();

  useEffect(() => {
    if (editData) {
      setValue("key", editData.key);
      setValue("heading", editData.heading);
      setValue("email", editData.email);
      setValue("address1", editData.address1);
      setValue("address2", editData.address2);
      setValue("phone", editData.phone);
      setValue("countryIdentifier", editData.countryIdentifier);
      setValue("mapElement", editData.mapElement);
    }
  }, [editData, setValue]);

  const CountryKeys = [
    { value: "contact_usa", label: "USA" },
    { value: "contact_ger", label: "Germany" },
    { value: "contact_ner", label: "Netherlands" },
    { value: "contact_italy", label: "Italy" },
    { value: "contact_uk", label: "UK" },
    { value: "contact_france", label: "France" },
    { value: "contact_china", label: "China" },
    { value: "contact_sing", label: "Singapore" },
    { value: "contact_uae", label: "Uae" },
  ];

  const onSubmit = async (data) => {
    // const resp = await PatchRequest(`${ApiUrl.configuration}/${editData.id}`, {
    //   value: JSON.stringify({
    //     heading: data.heading,
    //     email: data.email,
    //     address1: data.address1,
    //     address2: data.address2,
    //     phone: data.phone,
    //   }),
    // });
    let Req = fulldata ?? [];
    if (editData) {
      Req = Req.map((item) =>
        item.key === editData.key ? { ...data, key: editData.key } : item
      );
      console.log(Req);
    } else {
      Req.push({ ...data, key: Date.now().toString() });
    }

    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.contact}`,
      { country: Req }
    );

    const closeButton = document.querySelector(
      '#edit-units [data-bs-dismiss="modal"]'
    );

    if (resp && closeButton) {
      closeButton.click();
      OnFinish();
      reset();
    }
  };

  return (
    <div>
      {/* Edit Unit */}
      <div className="modal fade" id="edit-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Contact Details</h4>
                  </div>
                  <button
                    id="closebutton"
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => reset()}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    {/* <div className="mb-3">
                      <label className="form-label">Key</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="key for contact us Map"
                        {...register("key", {
                          required: "name is required",
                        })}
                      />
                    </div> */}
                    <div className="mb-3">
                      <label className="form-label">Heading</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("heading", {
                          required: "name is required",
                        })}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        {...register("email")}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Address 1</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("address1")}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Address 2</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("address2")}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("phone")}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Country Identifier</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("countryIdentifier")}
                      />
                    </div>
                    <div className="mb-3">
                      <div className="input-blocks">
                        <label>Map Element</label>
                        <Select
                          options={CountryKeys}
                          placeholder="Choose Country"
                          classNamePrefix="react-select"
                          onChange={(val) => setValue("mapElement", val?.value)}
                        />
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                        onClick={() => reset()}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <span className="spinner-border spinner-border-sm"></span>
                        ) : (
                          "Save Details"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditContactUs;
